import { Component, forwardRef, Input, EventEmitter, Output } from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "ops-switch",
  templateUrl: "./switch.component.html",
  styleUrls: ["./switch.component.css"],
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OpsSwitchComponent),
      multi: true,
    },
  ],
})
export class OpsSwitchComponent implements ControlValueAccessor {
  private val: boolean;

  @Input() placeholder: string;
  @Input() label: string;
  @Input() class: string;
  @Input() disabled: boolean;
  @Output() changed: EventEmitter<boolean>;
  private onChange: (_data: boolean) => void;
  private onTouch: () => void;

  constructor() {
    this.disabled = false;
    this.changed = new EventEmitter<boolean>();
  }

  set value(val: boolean) {
    this.val = val;
    this.changed.emit(val);
    if (this.onChange) this.onChange(val);
    if (this.onTouch) this.onTouch();
  }

  get value() {
    return this.val;
  }

  writeValue(value: boolean) {
    this.value = value;
  }

  registerOnChange(fn: (_data: boolean) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouch = fn;
  }
}
